import {LogicalWidgetEnum} from "../../enums/widget";
import {LogicalWidget} from '../logical-widget';

export class WeatherCategoryLogicalWidget extends LogicalWidget{
  public selected: any = null;

  logical_widget_type(): LogicalWidgetEnum | null {
    return LogicalWidgetEnum.LOGICAL_WIDGET__WEATHER_CATEGORY;
  }

  constructor() {
    super();
  } // end constructor
} // end Package

